export class DentalCodeModel {
    code_no: string
    code_name: string

    constructor(
        code_no: string,
        code_name: string
    ) {
        this.code_no = code_no
        this.code_name = code_name
    }
}